import { render, staticRenderFns } from "./property_details.vue?vue&type=template&id=1a52c7b5"
import script from "./property_details.vue?vue&type=script&lang=js"
export * from "./property_details.vue?vue&type=script&lang=js"
import style0 from "./property_details.vue?vue&type=style&index=0&id=1a52c7b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports